import { normalize as s } from "../normalize.js";
import { Schema as a } from "./schema.js";
import { DefinedInfo as c } from "./defined-info.js";
const u = {}.hasOwnProperty;
function w(e) {
  const p = {}, t = {};
  let r;
  for (r in e.properties)
    if (u.call(e.properties, r)) {
      const m = e.properties[r], o = new c(
        r,
        e.transform(e.attributes || {}, r),
        m,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), p[r] = o, t[s(r)] = r, t[s(o.attribute)] = r;
    }
  return new a(p, t, e.space);
}
export {
  w as create
};
//# sourceMappingURL=create.js.map
